export const GET_LOAN_AMENDMENTS = 'loan_amendment/GET_LOAN_AMENDMENTS'
export const GET_LOAN_AMENDMENT = 'loan_amendment/GET_LOAN_AMENDMENT'
export const GET_LOAN_AMENDMENTS_BY_FACILITY =
  'loan_amendment/GET_LOAN_AMENDMENTS_BY_FACILITY'
export const ADD_LOAN_AMENDMENTS = 'loan_amendment/ADD_LOAN_AMENDMENTS'
export const EDIT_LOAN_AMENDMENTS = 'loan_amendment/EDIT_LOAN_AMENDMENTS'
export const SUBMIT_LOAN_AMENDMENT = 'loan_amendment/SUBMIT_LOAN_AMENDMENT'
export const REJECT_LOAN_AMENDMENT = 'loan_amendment/REJECT_LOAN_AMENDMENT'
export const APPROVE_LOAN_AMENDMENT = 'loan_amendment/APPROVE_LOAN_AMENDMENT'
export const DELETE_LOAN_AMENDMENT = 'loan_amendment/DELETE_LOAN_AMENDMENT'
export const START_LOADING_LOAN_AMENDMENTS =
  'loan_amendment/START_LOADING_LOAN_AMENDMENTS'
export const STOP_LOADING_LOAN_AMENDMENTS =
  'loan_amendment/STOP_LOADING_LOAN_AMENDMENTS'
export const START_LOADING_FACILITY_LOAN_AMENDMENTS =
  'loan_amendment/START_LOADING_FACILITY_LOAN_AMENDMENTS'
export const STOP_LOADING_FACILITY_LOAN_AMENDMENTS =
  'loan_amendment/STOP_LOADING_FACILITY_LOAN_AMENDMENTS'
